import {
  CreatorRoutes,
  EventRoutes,
  HomeRoutes,
  IdentityRoutes,
  MountainviewRoutes,
  ProfileRoutes,
} from 'navigation/routes';

export const Routes = {
  ...CreatorRoutes,
  ...EventRoutes,
  ...HomeRoutes,
  ...IdentityRoutes,
  ...MountainviewRoutes,
  ...ProfileRoutes,
};